const BASE_USER_ACTION = "USER";
export const SET_USER_DATA = `${BASE_USER_ACTION}/SET_USER_DATA`;
export const RESET_USER_DATA = `${BASE_USER_ACTION}/RESET_USER_DATA`;
